import { initializeErrorReporting } from '@eb/error-reporting';
import React from 'react';
import { render } from 'react-dom';
import App from './app';
import {
    initDimensionsFromState,
    trackInitialPageView,
} from '@eb/site-analytics';
import {
    getLocaleOverride,
    setupAsync,
    getParentLocale,
} from '@eventbrite/i18n';

// retrieve data from server to hydrate the client
const props = window.__SERVER_DATA__ || {};
const parentLocale = getParentLocale(
    getLocaleOverride() || props.env.localeInfo.locale,
);

const main = async () => {
    initializeErrorReporting();
    try {
        if (parentLocale !== 'en_US') {
            await setupAsync({
                parentLocale,
                translations: /* webpackChunkName: "assortments-i18n-translation" */ import(
                    `./i18n/translations/${parentLocale}.json`
                ),
            });
        }
    } finally {
        render(<App {...props} />, document.getElementById('root'));
    }
};
main();

initDimensionsFromState(props);
trackInitialPageView(props.gaSettings);
